var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 6.75H18.3333M6.66667 11.5H11.3333M12.5 21L7.83333 16.25H4.33333C3.04467 16.25 2 15.1867 2 13.875V4.375C2 3.06332 3.04467 2 4.33333 2H20.6667C21.9553 2 23 3.06332 23 4.375V13.875C23 15.1867 21.9553 16.25 20.6667 16.25H17.1667L12.5 21Z",
    stroke: "#11047A",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f4b20ae800e349efcdbab5dbaa5cc2c8.svg";
export { ForwardRef as ReactComponent };